import { ADD_CUSTOMER_ADDRESS_URL, GENERATE_OTP_URL, UPDATE_CUSTOMER_ADDRESS_URL, UPDATE_CUSTOMER_URL, VERIFY_OTP_URL, DELETE_CUSTOMER_ADDRESS_URL, SET_DEFAULT_ADDRESS_URL } from "../../services/api-service";
import actionTypes from "../action-types";

const generateOtpAction = (data) => {
  return {
    type: actionTypes.GENERATE_OTP,
    payload: {
      url: GENERATE_OTP_URL,
      data,
    },
  };
};

const verifyOtpAction = (data) => {
  return {
    type: actionTypes.VERIFY_OTP,
    payload: {
      url: VERIFY_OTP_URL,
      data,
    },
  };
};

const updateCustomerInfoAction = (data, customerId) => {
  return {
    type: actionTypes.EDIT_CUSTOMER_INFO,
    payload: {
      url: UPDATE_CUSTOMER_URL,
      data,
      customerId
    },
  };
};

const addCustomerAddressAction = (data, customerId) => {
  return {
    type: actionTypes.ADD_CUSTOMER_ADDRESS,
    payload: {
      url: ADD_CUSTOMER_ADDRESS_URL,
      data,
      customerId
    },
  };
};

const updateCustomerAddressAction = (data, customerId) => {
  return {
    type: actionTypes.EDIT_CUSTOMER_ADDRESS,
    payload: {
      url: UPDATE_CUSTOMER_ADDRESS_URL,
      data,
      customerId
    },
  };
};

const removeCustomerAddressAction = (customerId, addressId) => {
  return {
    type: actionTypes.REMOVE_CUSTOMER_ADDRESS,
    payload: {
      url: DELETE_CUSTOMER_ADDRESS_URL,
      customerId, addressId,
    },
  };
};

const setDeafultAddressAction = (customerId, addressId) => {
  return {
    type: actionTypes.SET_DEFAULT_ADDRESS,
    payload: {
      url: SET_DEFAULT_ADDRESS_URL,
      customerId, addressId
    },
  };
};


const AccountActions = {
  generateOtpAction,
  verifyOtpAction,
  updateCustomerInfoAction,
  updateCustomerAddressAction,
  addCustomerAddressAction,
  removeCustomerAddressAction,
  setDeafultAddressAction
};

export default AccountActions;
